const { FormatMoney } = require("format-money-js")

export const fm = new FormatMoney({
  decimals: 2,
  symbol: "₱",
})
